<app-tab>
  <app-fields-interventions-toolbar
    [request]="request"></app-fields-interventions-toolbar>


  <!--<app-fields-interventions-dashboard
    [hidden]="currentMenu.id !== 1 && backgroundMenu.id !== 1"
    [width]="width"
    [height]="height"
    [request]="request"></app-fields-interventions-dashboard>-->

  <app-fields-interventions-grid
    [hidden]="currentMenu.id !== 2 && backgroundMenu.id !== 2"
    [width]="width"
    [height]="height"
    [request]="request"></app-fields-interventions-grid>

  <app-fields-interventions-pivot-grid
    [hidden]="currentMenu.id !== 3 && backgroundMenu.id !== 3"
    [width]="width"
    [height]="height"
    [request]="request"></app-fields-interventions-pivot-grid>

  <!--<app-fields-interventions-settings
    [visible]="currentMenu.id === 4"
    [width]="width"
    [height]="height"
    [request]="request"></app-fields-interventions-settings>-->
</app-tab>
